export default "__VITE_ASSET__Hy3gFdQR__"